import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { BarChart } from '../../../commonModules/interface/Chart';
import {Bar, Line, Doughnut} from 'react-chartjs-2';
import { isEmpty } from "lodash";
import { Box, Card, Grid, Table, TableBody, TableRow, TableCell } from '@material-ui/core';
import { fetchSubscriptions } from '../../../../../../jsx/actions/subscriptionAction';

class RecoveryStats extends Component {
    state = { 
        totalLate: 0,
        averageDays: 0,
        aboList: {},
        percentage: {},
        bg: [],
        percentage2: {},
        bg2: [],
        lateLevels: {},
        bg3: [],
        bgCalls: [],
        bgCallsU: [],
        bgCallsT: [],
        stats:{
            'today_nbCalls': "",
            'today_nbUnansweredCalls': "",
            'today_averageLengthCall': "",
            // 'nbActiveAlerts': "",
        },
        statsCalls:{},
        statsCallsU: {},
        statsCallsT: {},
    }
    componentDidMount() {
        if (!this.props.SUBSCRIPTIONS){
            this.props.fetchSubscriptions()         
        }
        this.calcLateAmount()
        this.fetchStatsInfo()
        this.fetchCallsStatsList()
    }
    calcLateAmount = () => {
        const { LATE, CLIENTS, SUBSCRIPTIONS, STATS } = this.props;

        let nbLateClients = LATE.length
        let totalLate = 0
        let averageDays = 0
        let aboList = {}
        let percentage = {}
        let bg = []
        let percentage2 = {}
        let bg2 = []
        let lateLevels = {
            "Moins de 2 Semaines": 0,
            "Moins d'un Mois": 0,
            "Moins de 2 Mois": 0,
            "Moins de 3 Mois": 0,
            "Plus de 3 Mois": 0,
        }
        // let bg3 = [
        //     'rgba(255, 206, 86, 0.6)',
        //     'rgba(54, 162, 235, 0.6)',
        //     'rgba(255, 99, 132, 0.6)',
        //     'rgba(10, 142, 61, 0.6)',
        //     'rgba(255, 0, 0, 0.6)',
        //     // 'rgba(75, 192, 192, 0.6)',
        // ]
        let bg3 = [
            'rgba(0, 135, 0, 0.6)',
            'rgba(176, 218, 120, 0.6)',
            'rgba(254, 252, 92, 0.6)',
            'rgba(230, 133, 33, 0.6)',
            'rgba(255, 0, 0, 0.6)',
            // 'rgba(254, 171, 92, 0.6)',
            // 'rgba(75, 192, 192, 0.6)',
        ]

        LATE.forEach( ID => {
            let client = CLIENTS[ID].resume

            let levels = [14, 31, 60, 90]

            let delay = client.paymentDelay * -1
            let nbPeriod = Math.floor(delay / client.periodicity)
            
            totalLate += nbPeriod * client.nextPaymentAmount  
            averageDays += delay
            
            aboList[client.subscriptionID] = (aboList[client.subscriptionID] || 0 ) + 1

            if( delay < levels[0] ){
                lateLevels["Moins de 2 Semaines"] += 1
            } else if( delay < levels[1] ){
                lateLevels["Moins d'un Mois"] += 1
            } else if( delay < levels[2] ){
                lateLevels["Moins de 2 Mois"] += 1
            } else if( delay < levels[3] ){
                lateLevels["Moins de 3 Mois"] += 1
            } else {
                lateLevels["Plus de 3 Mois"] += 1
            }
        })

        Object.keys(aboList).forEach( aboID => {
            let aboName = SUBSCRIPTIONS ? SUBSCRIPTIONS[aboID].name : aboID

            percentage[aboName] = Math.round(aboList[aboID] * 10000 / nbLateClients) / 100;
            bg.push('rgba(230, 60, 134, 0.6)')

            percentage2[aboName] = Math.round(aboList[aboID] * 10000 / STATS[aboID]) / 100;
            bg2.push('rgba(111, 198, 215, 0.6)')
        });

        console.table(aboList, percentage, percentage2)

        this.setState({
            totalLate,
            averageDays: Math.round(averageDays / nbLateClients),
            aboList,
            percentage,
            bg,
            percentage2,
            bg2,
            lateLevels,
            bg3
        })
    }
    
    fetchStatsInfo = async () => {
        try {
            const res = await fetch("/recovery/general/stats", {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
            });            
            const resp = await res.json();
            console.log('====================================');
            console.log("[INFO], FETCH STATS INFO", resp);
            console.log('====================================');
            if(resp.content){
                this.setState({stats: resp.content})
            }
        } catch (error) {
            console.log("[ERROR], fetchStatsInfo, recoveryStats.jsx", error);
        }
    }
    fetchCallsStatsList = async () => {
        try {
            const res = await fetch("/recovery/calls/stats", {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
            });            
            const resp = await res.json();
            console.log('====================================');
            console.log("[INFO], FETCH CALLS STATS", resp);
            console.log('====================================');

            let statsCalls = {}
            let statsCallsU = {}
            let statsCallsT = {}
            let bgCalls = []
            let bgCallsU = []
            let bgCallsT = []

            if( resp.content ){
                resp.content.forEach( dayStat => {
                    // let random = Math.floor(Math.random() * Math.floor(49))
                    // let random2 = Math.floor(Math.random() * Math.floor(random))
                    // statsCalls[new Date(dayStat.ts).toLocaleDateString("fr-FR")] = random
                    // statsCallsU[new Date(dayStat.ts).toLocaleDateString("fr-FR")] = random2
                    // statsCallsT[new Date(dayStat.ts).toLocaleDateString("fr-FR")] = random + random2

                    statsCalls[new Date(dayStat.ts).toLocaleDateString("fr-FR")] = dayStat.val[0]
                    statsCallsU[new Date(dayStat.ts).toLocaleDateString("fr-FR")] = dayStat.val[1]
                    statsCallsT[new Date(dayStat.ts).toLocaleDateString("fr-FR")] = dayStat.val[0] + dayStat.val[1]

                    bgCalls.push( 'rgba(255, 203, 96, 0.8)' )
                    bgCallsU.push( 'rgba(111, 198, 215, 0.7)' )
                    bgCallsT.push( 'rgba(196, 105, 143, 0.6)' )
                })
            }

            this.setState({statsCalls, statsCallsU, statsCallsT ,  bgCalls, bgCallsU, bgCallsT})
        } catch (error) {
            console.log("[ERROR], fetchCallsStatsList, recoveryStats.jsx", error);
        }
    }
    render() {
        const { LATE, SUBSCRIPTIONS } = this.props;
        const { 
            percentage,
            percentage2,
            bg,
            bg2,
            bg3,
            bgCalls,
            bgCallsU,
            bgCallsT,
            statsCalls,
            statsCallsU,
            statsCallsT,
            lateLevels,
            aboList,
            stats
        } = this.state;

        if(isEmpty(this.state.percentage) && !isEmpty(LATE) && !isEmpty(SUBSCRIPTIONS)){
            this.calcLateAmount()
        }

        const data = {
            labels: Object.keys(percentage),
            datasets:[
                {
                    label:'Part par rapport aux retards (%)',
                    data: Object.values(percentage),
                    backgroundColor:bg,
                },
                {
                    label:'Part par rapport à l\'abonnement (%)',
                    data: Object.values(percentage2),
                    backgroundColor:bg2,
                },
            ]
        }
    
        const data2 = {
              labels: Object.keys(percentage),
              datasets:[
                {
                label:'Nombre de clients',
                data: Object.values(aboList),
                backgroundColor:bg,
                },
              ]
        }
        const data3 = {
            labels: Object.keys(lateLevels),
            datasets:[
                {
                    data:Object.values(lateLevels),
                    backgroundColor:bg3,
                }
            ]
        }
        const data4 = {
            labels: Object.keys(statsCalls),
            datasets:[
                {
                    label:"Sans réponse",
                    data:Object.values(statsCallsU),
                    backgroundColor:bgCallsU,
                },
                {
                    label: "Avec réponse",
                    data:Object.values(statsCalls),
                    backgroundColor:bgCalls,
                },
                {
                    label: "Total",
                    data:Object.values(statsCallsT),
                    backgroundColor:bgCallsT,
                },
            ]
        }
        return (
            <Card>
                <Box p={2}>
                    <h4>Stats</h4>

                    <div className="table-responsive">
                        <Grid spacing={2} container>
                            <Grid sm={6} xs={12} >
                                <Table className="table table-striped">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Nombre d'appels passé Aujourd'hui</TableCell>
                                            <TableCell>{stats.today_nbCalls}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Nombre d'appels sans réponse</TableCell>
                                            <TableCell>{stats.today_nbUnansweredCalls}</TableCell>
                                        </TableRow>

                                    </TableBody>
                                </Table>
                            </Grid>
                    
                            <Grid sm={6} xs={12} >
                                <Table className="table table-striped">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Durée moyenne des Appels</TableCell>
                                            <TableCell>{stats.today_averageLengthCall}</TableCell>
                                        </TableRow>
                                        
                                        <TableRow>
                                            <TableCell>Somme Totale Due</TableCell>
                                            <TableCell>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(this.state.totalLate)}</TableCell>
                                        </TableRow>
                                        
                                    </TableBody>
                                </Table>
                            </Grid>
                        </Grid>
                    
                        <hr/>                    
                    </div>

                    {!isEmpty(LATE) && 
                    <Box p={2}>
                        <div className="chart">
                            <Line
                                data={data4}
                                options={{
                                    title:{
                                        display: true,
                                        text:"Nombre d'appels par jour",
                                        fontSize:18
                                    },
                                }}
                            />
                        </div>
                        <hr/>
                        {/* <div className="chart">
                            <Doughnut
                                data={data3}
                                options={{
                                    title:{
                                        display: true,
                                        text:"Tendance des retards",
                                        fontSize:18
                                    },
                                }}
                            />
                        </div> */}
                        <hr/>
                        <div className="chart">
                            <Bar
                                data={data}
                                options={{
                                    title:{
                                        display: true,
                                        text:"Repartion des retards par type d'abonnement",
                                        fontSize:18
                                    },
                                }}
                            />
                        </div>
                        <hr/>
                        <div className="chart">
                            <Bar
                                data={data2}
                                options={{
                                    title:{
                                        display: true,
                                        text:"Repartion des retards par type d'abonnement",
                                        fontSize:18
                                    },
                                }}
                            />
                        </div>

                    </Box>
                }
                </Box>
            </Card>
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        SUBSCRIPTIONS: state.subscriptions,
        STATS: state.stats.SUBSCRIPTIONS,
        CLIENTS: state.clients,
        LATE: state.recovery.LATE,   
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        // getRecoveryList
        fetchSubscriptions
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps )(RecoveryStats);